module.exports = "/templates/bds/public/images/7f31a203b54006f722a199ddf892c0e1.png";